




























import Vue, { PropType } from 'vue';
import AppLogo from '@/components/molecules/appLogo/AppLogo.vue';
import MetaNavigation from '@/components/molecules/metaNavigation/MetaNavigation.vue';
import MainNavigation from '@/components/molecules/mainNavigation/MainNavigation.vue';
import type { HeaderContent } from '@/api/interfaces/content/app/headerContent';
import { ImageLinkContent } from '@/api/interfaces/content/app/imageLinkContent';

export default Vue.extend({
    name: 'AppHeader',
    components: {
        AppLogo,
        MetaNavigation,
        MainNavigation,
    },
    props: {
        headerContent: {
            type: Object as PropType<HeaderContent>,
            default: {},
        },
        hamburgerMenuOpen: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        logoContent(): ImageLinkContent | undefined {
            let logoContent =
                this.headerContent.logoContent ??
                ({
                    linkUrl: '/',
                } as ImageLinkContent);

            if (!logoContent.image) {
                // Set static image as fallback, when no content-image was provided.
                logoContent.image = {
                    path: '/assets/img/logo-ewe-netz.svg',
                    alt: 'Ewe Netz Logo',
                    title: 'Ewe Netz Logo',
                };
            }

            return logoContent;
        },
    },
});
